/* @ngInject */
export const feedbackSessionStatus = (Session, $filter) => {
	return (session) => {
		return $filter('translate')(Session.getReadableStatus(session));
	};
};
